import { defineComponent } from 'vue';
import props from './description-item-props';

export default defineComponent({
  name: 'TDescriptionsItem',
  props,
});
